"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _button = require("../button");

var _context = require("../context");

var _utils = require("../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledInputActionButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'neutral90' : _ref$iconColor,
      selectors = _ref.theme.selectors;
  return {
    border: 'none',
    color: selectors.color(iconColor),
    ':focus': _objectSpread({
      outlineOffset: _constants.INSET_ELEMENT_OUTLINE_OFFSET
    }, iconColor ? {
      outlineColor: selectors.color(iconColor)
    } : {})
  };
});

var InputActionButtonWithoutDocs = function InputActionButtonWithoutDocs(_ref2) {
  var Icon = _ref2.icon,
      iconColor = _ref2.iconColor,
      altText = _ref2.altText,
      innerRef = _ref2.innerRef,
      onClick = _ref2.onClick,
      tabIndex = _ref2.tabIndex,
      type = _ref2.type,
      disabled = _ref2.disabled;
  return (0, _core.jsx)(StyledInputActionButton, {
    type: type,
    disabled: disabled,
    icon: (0, _core.jsx)(Icon, {
      title: altText,
      color: iconColor
    }),
    iconColor: iconColor,
    onClick: onClick,
    ref: innerRef,
    size: _button.ButtonSize.Small,
    tabIndex: tabIndex,
    variant: _button.ButtonVariant.Tertiary
  });
};

var InputActionButtonWithDocs = (0, _stencilReactDesc.describe)(InputActionButtonWithoutDocs).description('Pre-configured `Button` component for use as an action button in an input field.');
InputActionButtonWithDocs.propTypes = {
  icon: _stencilReactDesc.PropTypes.func.description('Icon component for the action button.').isRequired,
  iconColor: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'color' property for the element."),
  altText: _stencilReactDesc.PropTypes.string.description('Alt text for the icon in the action button.')
};
var InputActionButton = (0, _utils.withTestAttributes)({
  component: 'StencilInputActionButton'
})(InputActionButtonWithDocs);
InputActionButton.displayName = 'InputActionButton';
var _default = InputActionButton;
exports.default = _default;